/**
 * Debug utilities for cache and version management
 * Available in browser console as window.HealthLoopDebug
 */

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as versionCheck from './versionCheck';

const debug = {
  // Get current app version
  getVersion: () => {
    console.log('📦 Current Version:', versionCheck.getCurrentVersion());
    return versionCheck.getCurrentVersion();
  },

  // Get service worker version
  getServiceWorkerVersion: async () => {
    const version = await serviceWorkerRegistration.getServiceWorkerVersion();
    console.log('🔧 Service Worker Version:', version);
    return version;
  },

  // Force update check
  checkForUpdates: async () => {
    console.log('🔍 Checking for updates...');
    return await versionCheck.forceVersionCheck();
  },

  // Clear all caches
  clearCaches: async () => {
    console.log('🗑️ Clearing all caches...');
    return await serviceWorkerRegistration.clearAllCaches();
  },

  // Reset app completely
  resetApp: async () => {
    console.log('💣 Resetting app...');
    if (confirm('This will clear all app data and reload. Continue?')) {
      return await versionCheck.resetApp();
    }
    return false;
  },

  // Force reload
  reload: () => {
    console.log('🔄 Force reloading...');
    window.location.reload(true);
  },

  // Show all localStorage data
  showStorage: () => {
    console.log('💾 LocalStorage:');
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      console.log(`  ${key}:`, localStorage.getItem(key));
    }
    
    console.log('💾 SessionStorage:');
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      console.log(`  ${key}:`, sessionStorage.getItem(key));
    }
  },

  // Show all caches
  showCaches: async () => {
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      console.log('📦 Caches:', cacheNames);
      return cacheNames;
    }
    return [];
  },

  // Show service worker status
  showServiceWorkerStatus: async () => {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.ready;
      console.log('🔧 Service Worker Status:', {
        active: !!registration.active,
        waiting: !!registration.waiting,
        installing: !!registration.installing,
        scope: registration.scope
      });
      return registration;
    }
    return null;
  },

  // Help command
  help: () => {
    console.log(`
🔧 HealthLoop Debug Commands:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Version Management:
  window.HealthLoopDebug.getVersion()
  window.HealthLoopDebug.getServiceWorkerVersion()
  window.HealthLoopDebug.checkForUpdates()

Cache Management:
  window.HealthLoopDebug.clearCaches()
  window.HealthLoopDebug.showCaches()
  window.HealthLoopDebug.resetApp()

Debugging:
  window.HealthLoopDebug.showStorage()
  window.HealthLoopDebug.showServiceWorkerStatus()
  window.HealthLoopDebug.reload()
  window.HealthLoopDebug.help()

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
    `);
  }
};

// Expose to window for console access
if (typeof window !== 'undefined') {
  window.HealthLoopDebug = debug;
  console.log('🔧 Debug commands available! Type: window.HealthLoopDebug.help()');
}

export default debug;
